// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac9cff00","453":"e7776b4d","553":"18074283","977":"ace9dcb3"}[chunkId] + ".chunk.js";
};